import request from '@/utils/request'

export default {
    index: function () {//账单
      return request({
          url: 'task/fund/index',
          method: 'post',
      });
    },
    cashPre: function () {//提现前置
        return request({
            url: 'task/fund/cashPre',
            method: 'post',
        });
    },
    cash: function (form) {//申请提现
        return request({
            url: 'task/fund/cash',
            method: 'post',
            data: form
        });
    },
    cashOrderList: function (form) {//提现记录
        return request({
            url: 'task/fund/cashOrderList',
            method: 'post',
            data: form
        });
    },
    settleOrderList: function (form) {//结算记录
        return request({
            url: 'task/fund/settleOrderList',
            method: 'post',
            data: form
        });
    },
}
